import React, { useRef } from 'react'
import css from './style.module.css'
import Button from '../../../../SPRINTA/v2/atoms/Button'
import Display from '../../../../SPRINTA/v2/atoms/Display'
import T from '../../../../SPRINTA/translate/T'

function UploadFile ( { progress, handleFile, title, ...props } ) {
    
    const files = useRef(null);

    function change(e) {
        let el = e.target
        let file = el.files[0]

        handleFile(file)
    }

    return (
        <div className={css.boxUpload} style={props.style}>
            <div className={css.titleUpload}>
                <Display size={3}>{title}</Display>
            </div>
            
            {progress ? 
                
                (<div className={css.progressBox}><div className={css.loadingDiv} style={{width: progress ? `${progress}%` : '0%'}} /></div>) : 

                (   
                    <div className={css.contentUpload}>
                        <input ref={files} type='file' hidden onChange={(e) => change(e)} />
                        <input placeholder={T.txt('upload_placeholder')} readOnly type='text' onClick={() => { files.current.click() }} />
                        <Button type='button' inline primary onClick={() => { files.current.click() }}>Procurar</Button>
                    </div>
                )
            }    

        </div>
    )

}

export default UploadFile


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/molecules/UploadFile/index.js